import { styled } from "../theme";

export const ChartCont = styled("div", {
  position: "relative",
  width: "100%",
  height: "100%"
});
